import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useSession } from "../stores/session";

export default function ChangePassword() {
  const { user, refresh } = useSession();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setError("");
    if (next.length < 4 || next.length > 64) return setError("新密码需 4-64 位");
    if (next !== confirm) return setError("两次输入的新密码不一致");
    setLoading(true);
    try {
      await api.changePassword(current, next);
      const nextUser = await refresh();
      nav(nextUser?.role === "super_admin"
        ? "/admin/overview"
        : nextUser?.role === "mayor"
          ? "/console/overview"
          : nextUser?.homeTownId ? `/town/${nextUser.homeTownId}` : "/town", { replace: true });
    } catch (e: any) {
      setError(e.message || "修改失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f3f0e6] px-5">
      <div className="w-full max-w-md rounded-xl border border-[#ddd7c4] bg-white p-7 shadow-sm">
        <h1 className="text-xl font-black">修改密码</h1>
        <p className="mt-2 text-sm leading-6 text-[#77705f]">
          {user?.mustChangePassword ? "首次登录需要设置新密码后才能进入控制台。" : "更新当前账号的登录密码。"}
        </p>
        <div className="mt-6 space-y-3">
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
            placeholder="当前密码" className="w-full rounded-lg border border-[#d8d2bf] px-3 py-2.5 outline-none focus:border-[#2f6e5b]" />
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)}
            placeholder="新密码" className="w-full rounded-lg border border-[#d8d2bf] px-3 py-2.5 outline-none focus:border-[#2f6e5b]" />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="再次输入新密码" className="w-full rounded-lg border border-[#d8d2bf] px-3 py-2.5 outline-none focus:border-[#2f6e5b]" />
        </div>
        {error && <p className="mt-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button disabled={loading} onClick={submit}
          className="mt-5 w-full rounded-lg bg-[#2f6e5b] px-4 py-2.5 font-bold text-white disabled:opacity-50">
          {loading ? "提交中..." : "确认修改"}
        </button>
      </div>
    </div>
  );
}
